<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :loading="modalLoading"
      :data="queryElasticacheList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="elasticCacheDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="elasticCacheDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#ff6600;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ Name }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteElasticCache()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let tableElastiCache = {};
export default {
  name: "TableElastiCache",
  props: ["getAccountType"],
  data() {
    return {
      accountType: "",
      accountName: "",
      cacheClusterId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      Name: "",
      modalLoading: true,
      elasticCacheDelmodal: false,
      isDisable: false,
      columns: [
        {
          title: this.$t("permission_configuration_management.group.account"),
          key: "accountName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.accountType"
          ),
          key: "accountTypeName"
        },
        {
          title: this.$t("permission_configuration_management.resourcePermission.nodeName"),
          key: "cacheClusterId"
        },
        {
          title: this.$t("permission_configuration_management.resourcePermission.clusterName"),
          key: "replicationGroupIdString"
        },
        {
          title: this.$t("permission_configuration_management.resourcePermission.cacheEngine"),
          key: "cacheEngineName"
        },
        {
          title: this.$t("permission_configuration_management.resourcePermission.nodeType"),
          key: "cacheNodeType"
        },
        {
          title: this.$t("permission_configuration_management.group.status"),
          key: "cacheClusterStatusName"
        },
        {
          title: this.$t("permission_configuration_management.group.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "actions"
        }
      ],
      queryElasticacheList: []
    };
  },
  beforeCreate: function() {
    tableElastiCache = this;
  },
  methods: {
    // 点击备份目标的时候显示实例列表
    pagingQuery: function() {
      eventBus.$on("accountName", function(val) {
        tableElastiCache.accountName = val;
      });
      eventBus.$on("accountType", function(val) {
        tableElastiCache.accountType = val;
      });
      eventBus.$on("cacheClusterId", function(val) {
        tableElastiCache.cacheClusterId = val;
      });
      tableElastiCache.$api.adminGroupResourceAwsCacheRelationship
        .pagingQuery({
          groupId: this.$route.query.id,
          pageNum: this.current,
          pageSize: this.pageSize,
          accountType: this.getAccountType,
          accountName: tableElastiCache.accountName,
          cacheClusterId: tableElastiCache.cacheClusterId
        })
        .then(res => {
          this.modalLoading = false;
          this.queryElasticacheList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryElasticacheList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElastiCache.pagingQuery();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElastiCache.pagingQuery();
    },
    // 显示所有数据
    showAll: function() {
      tableElastiCache.pagingQuery();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.Name = this.queryElasticacheList[index].cacheClusterId;
    },
    // 删除
    deleteElasticCache: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      tableElastiCache.$api.adminGroupResourceAwsCacheRelationship
        .delete({
          groupId: this.$route.query.id,
          resourceAwsCacheId: this.queryElasticacheList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableElastiCache.pagingQuery();
            this.isDisable = false;
            this.elasticCacheDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableElastiCache.vue